export const state = {
  companies: [],
  activeCompany: null,
  requestStatus: 'loading',
};
